import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { showErrorToast, showSuccessToast } from "../utils/toaster";
import { baseurl } from "../config/url";

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const response = await axios.get(
          `${baseurl}/api/wishlist/get-wishlist/${userId}`
        );
        setWishlistItems(response.data?.items || []);
      } catch (error) {
        // showErrorToast("Error fetching wishlist:", error);
      }
    };

    fetchWishlist();
  }, []);

  const handleProductClick = (product) => {
    navigate(`/product/details/${product._id}`, { state: { product } });
  };

  const addToCart = async (product) => {
    try {
      const userId = localStorage.getItem("userId");
      await axios.post(`${baseurl}/api/cart/add-to-cart`, {
        userId,
        items: [{ productId: product._id, quantity: 1 }],
      });
      showSuccessToast(`${product.name} has been added to the cart.`);
      navigate("/cart");
    } catch (error) {
      // showErrorToast("Error adding to cart:", error);
    }
  };

  const deleteFromWishlist = async (productId) => {
    try {
      const userId = localStorage.getItem("userId");
      await axios.delete(`${baseurl}/api/wishlist/delete/${userId}`, {
        data: { userId, productId },
      });
      setWishlistItems(wishlistItems.filter((item) => item.productId._id !== productId));
      showSuccessToast("Item removed from wishlist.");
    } catch (error) {
      // showErrorToast("Error removing item from wishlist:", error);
    }
  };

  return (
    <div className="p-4 sm:p-8 bg-gray-50 min-h-screen flex flex-col items-center">
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4 text-center">
        Your Wishlist
      </h1>

      

      {wishlistItems.length > 0 ? (
        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">
          {wishlistItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md border border-gray-200 flex flex-col cursor-pointer hover:shadow-lg transition"
              onClick={() => handleProductClick(item.productId)}
            >
              {/* Image Section */}
              <div className="w-full aspect-[4/3] overflow-hidden border-b border-gray-300">
                <img
                  src={`data:${item?.productId?.image?.contentType};base64,${item?.productId?.image?.data}`}
                  alt={item.productId.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Info Section */}
              <div className="p-4 flex flex-col justify-between flex-grow">
                <h3 className="text-lg font-semibold text-gray-800">
                  {item.productId.name}
                </h3>
                <p className="text-gray-700 font-medium mt-1">
                  ₹ {item.productId.price}
                </p>
                <p className="text-gray-600 text-sm mt-1 line-clamp-2">
                  {item.productId.description}
                </p>

                <div className="mt-4 flex flex-col sm:flex-row gap-2">
                  <button
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm font-medium transition shadow-md w-full"
                    onClick={(e) => {
                      e.stopPropagation();
                      addToCart(item.productId);
                    }}
                  >
                    Add to Cart
                  </button>
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 text-sm font-medium transition shadow-md w-full"
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteFromWishlist(item.productId._id);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-600 text-center text-lg mt-20">
          You haven’t added anything yet. ✨ <br />
          Browse products and build your wishlist today!
        </p>
      )}



      <button
        onClick={() => navigate("/")}
        className="mt-20 flex flex-col bg-green-500 text-white px-6 py-2 rounded-full shadow hover:bg-green-700 transition"
      >
        Go to Home
      </button>
    </div>
  );
};

export default Wishlist;
